import React from 'react';

import FolderSearch from './FolderSearch';
import { SearchFolderProps } from './types';

function SearchFolder({ folderId, onChange }: SearchFolderProps) {
  return <FolderSearch folderId={folderId} onChange={onChange} />;
}

export default SearchFolder;
